import { Routes, Route } from "react-router-dom"
import "./App.scss"


// 페이지 import
import About from "./pages/About"
import News from "./pages/News"
import Event from "./pages/Event"
import Shop from "./pages/Shop"
import Login from "./pages/Login"
import Join from "./pages/Join"
import Marketplace from "./pages/Marketplace"

import Aboutabout from './pages/about/About-about';
import Aboutarchitecture from './pages/about/About-architecture';
import Aboutconcept from './pages/about/About-concept';

// 컴포넌트 import
import NavNoback from "./components/Nav-Noback.jsx"
import Footer from "./components/Footer.jsx"
import VerticalScrollBar from "./components/Horizon-ScrollBar"
import ButtonToTop from "./components/Button-ToTop"


// HOOK
import RouterToTop from "./hook/RouterToTop"








function App() {
   
   return (
      <div id='App'>
         <RouterToTop />
         <VerticalScrollBar />
         <NavNoback />
         {/* flow_font */}
         <div className='animationWrap'>
            <h2>LE CONTE DES CONTES LE CONTE DES CONTES LE CONTE DES CONTES LE CONTE DES CONTES LE CONTE DES CONTES LE CONTE DES CONTES</h2>
         </div>
         <div className='animationWrap animationWrap2 '>
            <h2>10, Yeonmujang 17-gil, Seongdong-gu, Seoul, Republic of Korea 10, Yeonmujang 17-gil, Seongdong-gu, Seoul, Republic of Korea</h2>
         </div>
         <Routes>
            <Route path="/" element={<About/>}>
               <Route path="/" element={<Aboutabout/>}></Route>
               <Route path="/Aboutarchitecture" element={<Aboutarchitecture/>}></Route>
               <Route path="/Aboutconcept" element={<Aboutconcept/>}></Route>
            </Route>
            <Route path="/News" element={<News/>}></Route>
            <Route path="/Event" element={<Event/>}></Route>
            <Route path="/Shop" element={<Shop/>}></Route>
            <Route path="/Marketplace" element={<Marketplace/>}></Route>
            
            <Route path="/Login" element={<Login/>}></Route>
            <Route path="/Join" element={<Join/>}></Route>
         </Routes>
         
         <Footer/>
         <ButtonToTop/>

      </div>
   )
}
export default App
